var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NavButton } from 'hx-navigator';
import { cn } from 'hx-util';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
export function NavigationButtonsContainer(_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", __assign({ className: cn('flex flex-row gap-4 sm:gap-10 mx-auto', className) }, { children: children })));
}
export function NavigationButton(_a) {
    var children = _a.children, label = _a.label, _b = _a.useDefaultClasses, useDefaultClasses = _b === void 0 ? true : _b, props = __rest(_a, ["children", "label", "useDefaultClasses"]);
    return (_jsx(NavButton, __assign({}, props, { className: cn({
            'sm:w-60 sm:max-w-60 py-3 w-36 max-w-36 disabled:bg-primary/40': useDefaultClasses,
        }, props.className) }, { children: _jsx("span", __assign({ className: "[text-box:trim-both_ex_alphabetic] py-2" }, { children: children || label || props.type })) })));
}
export function FormNavigationButton(_a) {
    var children = _a.children, label = _a.label, props = __rest(_a, ["children", "label"]);
    var widget = useSelector(function (state) { return state; }).widget;
    var formState = useFormContext().formState;
    var errors = formState.errors;
    return (_jsx(NavButton, __assign({}, props, { className: cn('sm:w-60 sm:max-w-60 py-3 w-36 max-w-36 disabled:bg-primary/40', props.className), disabled: (props.type === 'submit' && Boolean(Object.keys(errors).length)) ||
            widget.formSubmitted }, { children: _jsx("span", __assign({ className: "[text-box:trim-both_ex_alphabetic] py-2" }, { children: children || label || props.type })) })));
}
